import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Form, Input, FormGroup, Label, Button } from 'reactstrap';
import LoadingSpin from "react-loading-spin";

class ResDataView extends Component {
    static displayName = ResDataView.name;

    constructor(props)  {
        super(props);
        this.state = {
            permissionFlag: true,
            userInfo: this.props.reduxData.userInfo,
            studentData: []
        }
        this.apiFetch('ValidDepartments', { pagepk: "/ResDataView" }, "permissionFlag")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
            if (url == "ValidDepartments") {
                this.apiFetch("ResDataViewGetData", {}, "studentData")
            }
        }
        if (stateItem == "") {
            return data
        }
        if (stateItem == null) {
            
        }
    }

    componentDidMount() {

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            <h3>Your residency information for this year:</h3>
            {this.state.studentData.length > 0 ? < Table >
                <thead>
                    <tr>
                        <th>Semester</th>
                        <th>Building</th>
                        <th>Room</th>
                        <th>Room Type</th>
                        <th>Meal Plan</th>
                        <th>Roommate 1</th>
                        <th>Roommate 2</th>
                        <th>Roommate 3</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.studentData.map(item => (
                        <tr>
                            <td>{item.semester}</td>
                            <td>{item.building}</td>
                            <td>{item.room}</td>
                            <td>{item.roomtype}</td>
                            <td>{item.mealplan}</td>
                            <td>{item.roommate1_name.length > 0 ? <span>{item.roommate1_name} (<a href={"mailto:" + item.roommate1_email}>{item.roommate1_email}</a>)</span> : <span>None</span>}</td>
                            <td>{item.roommate2_name.length > 0 ? <span>{item.roommate2_name} (<a href={"mailto:" + item.roommate2_email}>{item.roommate2_email}</a>)</span> : <span>None</span>}</td>
                            <td>{item.roommate3_name.length > 0 ? <span>{item.roommate3_name} (<a href={"mailto:" + item.roommate3_email}>{item.roommate3_email}</a>)</span> : <span>None</span>}</td>
                            {item.roommate1_email.length > 0 && <td><Button href={"mailto:" + item.email_all}>Mail To All</Button></td>}
                        </tr>
                    ))}
                </tbody>
            </Table> : <LoadingSpin size="30px" primaryColor="#132E53" />}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(ResDataView);